import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { CreateFlashMessageRequest } from '../api/flashmessage/create/createflashmessagesrequest';
import { CreateFlashMessageResponse, CreateFlashMessageResponseDtoImpl } from '../api/flashmessage/create/createflashmessagesresponse';
import { CreateFlashMessageBuilder } from '../dto/flashmessage/create/flashmessagebuilder';

export class CreateFlashMessageAPIProcessorImpl extends APIProcessorImpl<CreateFlashMessageRequest, CreateFlashMessageResponse>
{
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new CreateFlashMessageResponseDtoImpl(APIFeatures.CREATE_FLASH_MESSAGE, "Create CreateFlashMessage Success");
                response.setFlashMessageResponseDto(new CreateFlashMessageBuilder(responseMapper.getResponseMap()).buildAll());
                
                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new CreateFlashMessageResponseDtoImpl(APIFeatures.CREATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new CreateFlashMessageResponseDtoImpl(APIFeatures.CREATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new CreateFlashMessageResponseDtoImpl(APIFeatures.CREATE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
      
            this.getAPIFailure(new CreateFlashMessageResponseDtoImpl(APIFeatures.CREATE_FLASH_MESSAGE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/createflashmessagesapiprocessor.tsx